import { ApplicationDocument } from '../types/application.types';

export const resolveApplicationOwnerUserId = (
  application: Partial<ApplicationDocument> | null | undefined
): string | null => {
  if (!application) {
    return null;
  }

  const userId = (application.userId || '').trim();
  if (userId) {
    return userId;
  }

  const legacyOwnerId = (application.owner_user_uid || '').trim();
  return legacyOwnerId || null;
};

export const resolveUserLinkedApplicationId = (
  userLike: {
    clientId?: string | null;
    primary_application_id?: string | null;
    linkedApplicationId?: string | null;
  } | null | undefined
): string | null => {
  if (!userLike) {
    return null;
  }

  const clientId = (userLike.clientId || '').trim();
  if (clientId) {
    return clientId;
  }

  const legacyApplicationId = (userLike.primary_application_id || '').trim();
  if (legacyApplicationId) {
    return legacyApplicationId;
  }

  const linkedApplicationId = (userLike.linkedApplicationId || '').trim();
  return linkedApplicationId || null;
};
